import axios from 'axios';
import { API_URL, END_POINT_QUOTES } from '../const';

// Preserve existing management choices; only fall back when View is denied.
export const getQuoteFormOptions = async (endpoint, resource, config) => {
  try {
    return await axios.get(API_URL + endpoint, config);
  } catch (error) {
    if (error.response?.status !== 403) throw error;
    const response = await axios.get(API_URL + END_POINT_QUOTES + '/form-options/' + resource, config);
    return { ...response, quoteFormFallback: true };
  }
};
